import { Box, Grid, Stack } from '@mui/joy';
import { get } from 'lodash';

import { FormField } from 'core/components';
import { FormSectionHeader } from 'core/elements';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { IPartFieldConfig } from 'parts/types';
import { Direction } from 'theme/enums';

import { buildInputProps, getUomOptions, hasUom, inputTypeFor, uomKeyFor } from './utils';

interface IProps {
  groupedConfigsPerColumn: Array<Array<[string, IPartFieldConfig[]]>>;
  detailsLabel: string;
}

export const FieldsBody = ({ groupedConfigsPerColumn, detailsLabel }: IProps) => {
  const { control, setValue, getValues, errors } = useFormContext();

  return (
    <Grid container spacing={2}>
      {groupedConfigsPerColumn.map((groupedConfigs, columnIndex) => {
        if (groupedConfigs.length === 0) {
          return null;
        }

        return (
          <Grid key={`column${columnIndex}`} xs={12} md={6}>
            <Stack sx={{ gap: 2 }}>
              {groupedConfigs.map(([groupName, configs], sectionIndex) => (
                <Stack key={`column${columnIndex}-section${sectionIndex}`} sx={{ gap: 1 }}>
                  <FormSectionHeader title={groupName || detailsLabel} />
                  {configs.map((config) => {
                    if (config.fieldId == null) {
                      return null;
                    }
                    const fieldName = String(config.fieldId);
                    const valueField = (
                      <FormField
                        name={fieldName}
                        type={inputTypeFor(config)}
                        inputProps={{
                          ...buildInputProps(config),
                          control,
                          setValue,
                          getValues,
                          error: get(errors, fieldName),
                        }}
                      />
                    );

                    if (!hasUom(config)) {
                      return <Box key={config.id ?? config.fieldId}>{valueField}</Box>;
                    }

                    const uomName = uomKeyFor(fieldName);

                    return (
                      <Stack
                        key={config.id ?? config.fieldId}
                        direction={Direction.ROW}
                        sx={{ gap: 1, alignItems: 'flex-end' }}
                      >
                        <Box sx={{ flex: 1 }}>{valueField}</Box>
                        <Box sx={{ minWidth: 100 }}>
                          <FormField
                            name={uomName}
                            type={InputType.SELECT}
                            inputProps={{
                              options: getUomOptions(config),
                              label: '',
                              control,
                              setValue,
                              getValues,
                              error: get(errors, uomName),
                            }}
                          />
                        </Box>
                      </Stack>
                    );
                  })}
                </Stack>
              ))}
            </Stack>
          </Grid>
        );
      })}
    </Grid>
  );
};
